import type { RouteObject } from "react-router-dom";

export const productKnowledgeRoutes: RouteObject[] = [
  {
    index: true,
    handle: { breadcrumb: "Product knowledge" },
    async lazy() {
      const { ProductKnowledgeEditsPage } = await import(
        "./product-knowledge-edits-page"
      );
      return { Component: ProductKnowledgeEditsPage };
    },
  },
];
